import { render, staticRenderFns } from "./VuetablePagination.vue?vue&type=template&id=1f08565e"
import script from "./VuetablePagination.vue?vue&type=script&lang=js"
export * from "./VuetablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f08565e')) {
      api.createRecord('1f08565e', component.options)
    } else {
      api.reload('1f08565e', component.options)
    }
    module.hot.accept("./VuetablePagination.vue?vue&type=template&id=1f08565e", function () {
      api.rerender('1f08565e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-datatable/Pagination/VuetablePagination.vue"
export default component.exports